<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Teacher Result Analysis</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="sem"
              :items="sem_list"
              item-text="sem"
              item-value="id"
              label="Semester"
              outlined
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="inst"
              :items="inst_list"
              item-text="name"
              item-value="inst_id"
              label="Employee"
              outlined
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="pt-3">
            <v-btn
              class="button"
              v-if="ay"
              @click="getReport()"
              :loading="loader"
              >Fetch Report</v-btn
            >
          </v-col>
        </v-row>

        <!-- excel btn code -->
        <v-row dense>
          <v-col cols="12" sm="6" md="6" v-if="result_analysis != ''">
            <!-- <v-btn rounded color="success" outlined @click="ExportToExcel()"
              ><v-icon color="success">mdi-export</v-icon>Export</v-btn
            > -->
            <v-btn
              rounded
              color="success"
              outlined
              @click="fnExcelReport('my-table-id', 'TeacherResultAnalysis')"
              :loading="loader"
              ><v-icon color="success">mdi-export</v-icon>Export</v-btn
            >
          </v-col>
        </v-row>
        <!-- excel code end -->
        <!-- <div v-for="(fl, index) in result_analysis" :key="index">
          <span v-for="(s, index) in fl.total" :key="index">
            <span v-if="s === null"></span> ddd{{ s }}
          </span>
          <br /><br />
          <span v-for="(s, index) in fl.percentage" :key="index">
            {{ s }}
          </span>
        </div> -->
        <div id="my-table-id">
          <v-simple-table
            v-if="result_analysis != ''"
            dense
            class="elevation-1 mytable"
            fixed-header
          >
            <thead>
              <tr>
                <th v-for="(fl, index) in result_analysis_values" :key="index">
                  {{ fl }}
                </th>
                <!-- <th>Classes</th> -->
                <!-- <th>Subject</th> -->
              </tr>
            </thead>
            <tbody v-for="(fl, index) in result_analysis" :key="index">
              <tr>
                <td style="width: 50px">{{ fl.name }}</td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[0] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[1] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[2] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[3] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[4] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[5] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[6] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[7] }} <br />
                  </span>
                </td>
                <td>
                  <span v-for="(s, index) in fl.crs_analysis_data" :key="index">
                    {{ s[8] }} <br />
                  </span>
                </td>
              </tr>
              <tr>
                <td align="center">
                  <b> Total </b>
                </td>
                <td v-for="(s, index) in fl.total" :key="index">
                  <span
                    ><b> {{ s }}</b>
                  </span>
                </td>
              </tr>
              <tr>
                <td align="center" colspan="4"><b> % </b></td>
                <td v-for="(s, index) in fl.percentage" :key="index">
                  <span
                    ><b> {{ s }}</b>
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    title: "",
    inst_list: [],
    inst: null,
    ay_list: [],
    ay: null,
    result_analysis: [],
    result_analysis_values: [],
    sem_list: [],
    sem: null,
  }),
  methods: {
    // ExportToExcel() {
    //   this.exs_loader = true;
    //   var htmltable = document.getElementById("my-table-id");
    //   var html = htmltable.outerHTML;
    //   window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
    //   this.exs_loader = false;
    // },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    getReport() {
      const data = {
        ay: this.ay,
        sem: this.sem,
        inst: this.inst,
      };
      this.loader = true;
      axios
        .post("/Examination/getTeacherResultAnalysisReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.result_analysis = res.data.result_analysis;
            this.result_analysis_values = res.data.result_analysis_values;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.loader = false;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.loader = false;
        })
        .finally(() => {
          this.loader = false;
        });
    },
    onLoad() {
      axios
        .post("/Examination/getResultAnalysisData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inst_list = res.data.inst_list;
            this.ay_list = res.data.ay_list;
            this.sem_list = res.data.sem_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  width: auto;
  font-size: small;
}
</style>
